import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { MarketCard } from "./MarketCard";

export const MarketRail = ({ title, products = [], viewAllTo, accent }) => {
  const ref = useRef(null);
  const scroll = (dir) => ref.current?.scrollBy({ left: dir * 600, behavior: "smooth" });
  if (!products.length) return null;
  return (
    <section className="mb-10" data-testid={`market-rail-${title.toLowerCase().replace(/\s+/g, "-")}`}>
      <div className="flex items-center justify-between mb-3">
        <h2 className={`text-lg md:text-xl font-black font-display tracking-tight ${accent ? "text-taven-orange" : ""}`}>{title}</h2>
        <div className="flex items-center gap-2">
          {viewAllTo && <Link to={viewAllTo} className="text-xs font-bold uppercase tracking-wider text-taven-gold hover:underline">View All</Link>}
          <button onClick={() => scroll(-1)} className="p-1.5 rounded-full border border-black/10 hover:bg-taven-gray" aria-label="Scroll left"><ChevronLeft className="w-4 h-4" /></button>
          <button onClick={() => scroll(1)} className="p-1.5 rounded-full border border-black/10 hover:bg-taven-gray" aria-label="Scroll right"><ChevronRight className="w-4 h-4" /></button>
        </div>
      </div>
      <div ref={ref} className="flex gap-4 overflow-x-auto pb-2 no-scrollbar" style={{ scrollbarWidth: "none" }}>
        {products.map((p) => (
          <div key={p.taven_product_id || p.handle} className="w-[150px] sm:w-[190px] shrink-0">
            <MarketCard product={p} />
          </div>
        ))}
      </div>
    </section>
  );
};

export default MarketRail;
